import { SOCKET_EVENTS } from "../../socket/Socket";
import { SCENE_INTERACTION } from "../../constants/scene";
import { WEBRTC_EVENTS } from "../../constants/webrtc";
import { v4 as uuidv4 } from 'uuid';
import { htmlEscaper, isMobile } from '../engine/helpers/worldHelpers';
import AudioLevelsAnalyzer from "../engine/helpers/audioLevelsAnalyzer";

import { GLOBAL_EVENTS } from "../../constants/global";

import { WebRTCAdaptor } from './media-server-external/webrtc_adaptor';
// import { getUrlParameter } from './media-server-external/fetch.stream';
const websocketURL = "wss://bagless-media-server.com:5443/WebRTCAppEE/websocket";
const pc_config = {
  'iceServers': [
    {
      urls: 'stun:stun.l.google.com:19302',
      // 'stun:apprc.bagless.io:5349',
    },
    // {
    //   urls: 'turn:apprc.bagless.io:5349',
    //   // urls: 'turn:apprc.bagless.io:5349?transport=udp',
    //   username: 'bagless',
    //   credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
    // },
    // {
    //   // urls: 'turn:apprc.bagless.io:5349',
    //   // urls: 'turn:apprc.bagless.io:5349?transport=udp',
    //   // username: 'bagless',
    //   // credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
    //   urls: 'turn:numb.viagenie.ca',
    //   credential: 'muazkh',
    //   username: 'webrtc@live.com'            
    // },
    // {
    //   urls: "turn:openrelay.metered.ca:80",
    //   username: "openrelayproject",
    //   credential: "openrelayproject",
    // },
    {
      urls: "turn:openrelay.metered.ca:443",
      username: "openrelayproject",
      credential: "openrelayproject",
    },

  ]
  // {
  //   urls: [
  //     // 'stun:stun.l.google.com:19302',
  //     'stun:apprc.bagless.io:5349',
  //   ],
  // },
  // {
  //   // urls: 'turn:numb.viagenie.ca',
  //   // credential: 'muazkh',
  //   // username: 'webrtc@live.com'            
  //   urls: 'turn:apprc.bagless.io:5349',
  //   // urls: 'turn:apprc.bagless.io:5349?transport=udp',
  //   username: 'bagless',
  //   credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
  // }
};


const sdpConstraints = {
  OfferToReceiveAudio: false,
  OfferToReceiveVideo: false
};
const publicsdpConstraints = {
  OfferToReceiveAudio: true,
  OfferToReceiveVideo: true

};
const publicMediaConstraints = {
  video: false,
  audio: false
};

class WebRtc {

  constructor(props) {
    this._socket = props.socket;
    this._model = props.model;

    this.userProperties = this._socket.getUserData();

    this._peerConnections = {};
    this._uuid = uuidv4();

    this.camAdaptor = null;
    this.screenAdaptor = null;
    this.roomOfStream = [];
    this.streamsList = [];
    this.publicStreamsList = [];
    this.usersList = {};
    this.interval = false;//cam
    this.interval2 = false;//screen
    this.publicInterval = false;//public
    this.roomTimerId = -1;

    this._currentScopeId = 0;
    this._currentScopeType = null;//scene, users
    this._currentScopeDisplayName = 'test scene';
    // My MediaStream objects
    this._local1on1Stream = null;
    this._localStream = null;
    this._localScreenStream = null;

    this._myVideoShareEnabled = false;
    this._myAudioShareEnabled = false;
    this.started = false;
    this.started1on1 = false;
    this.peerInfo = {};

    this.startedScreenShare = false;
    this.userProperties.userScreenShareOn = false;
    this.screenSender = null;
    this.screenObjId = null;

    this.currentScreenStreamId = null;
    this.screenShareEl = document.getElementById('initial-screen-share-video');

    this.myAudioLevelsAnalyzer = null;
    this.peerAudioLevelsAnalyzer = null;




    this.isMobile = isMobile();

    //TODO check if publicStage exists anywhere in the world because of scene change
    if (this._model.publicStage) {
      console.log('%c PUBLIC STAGE ' + this._model.publicStage, 'background:yellowgreen');
    }
    //If public stage exists in room
    this.publicAdaptor = null;//TODO test if one could handle this
    this.publicStageExists = this._model.publicStageExists();
    if (this.publicStageExists) {
    }
    // console.log('publicStageExists', this.publicStageExists);
    // instantiate publicAdaptor 
    this.IDsOfStreamObjs = this._model.getIDsOfStreamObjs();
    if (this.IDsOfStreamObjs.length > 0) {
      this.publicObjects = {};
      for (let i = 0; i < this.IDsOfStreamObjs.length; i++) {
        let el = this.IDsOfStreamObjs[i];
        this.publicObjects[el] = null;
      }
      // console.log('this.publicObjects',this.publicObjects);
    }

    this.controller();

  }

  updateUserProperties = () => {
    this.userProperties = this._socket.getUserData();
    // this.started && this.updateUserLabel();
    this.started1on1 && this.updateUserLabel();
    this.peerUsers = this._socket.getUsers();
  }

  updateUserLabel = () => {
    $("#localVideo").next().text(this.userProperties.userName);
    $("#localVideo").next().attr("data-user-id", this.userProperties.userId);
    $("#localVideo").next().attr("data-user-name", this.userProperties.userName);
  }

  aptisWebRtcData = (payload) => {
    // console.log('aptisWebRtcData',payload)
    this._handleSignalingData(payload.data);
  }
  aptisWebRtcSignalData = (payload) => {
    // console.log('aptisWebRtcSignalData',payload)
    this._handleSignalingMessagesData(payload.data);
  }

  _stopBroadcasting(streamId) {
    if (streamId === 'undefined' || streamId === undefined) {
      return;
    }

    $("#grid-view-option").addClass("disabled");

    if (this.camAdaptor) {
      console.log('%c _stopBroadcasting camAdaptor streamId:' + streamId, 'color: red; font-weight:bold; font-size:1em');

      if (!this.screenAdaptor) {
        //TODO check stoping when changing device
        // this.camAdaptor.leave(streamId);
        // console.log('roomId',$("#roomId").val());
        // this.camAdaptor.leaveFromRoom($("#roomId").val());
        // this.camAdaptor.stop(streamId);
        // this.camAdaptor.stop(streamId);
        // this.camAdaptor.closeStream(streamId);
        this.camAdaptor.closePeerConnection(streamId);
        this.camAdaptor.closeWebSocket();

      } else {
        this.camAdaptor.stop(streamId);
      }


      // console.log('_localStream',this._localStream);
      // console.log('_localStream getTracks',this._localStream.getTracks());
      if (document.getElementById('localVideo').srcObject) {
        let localVideo = document.getElementById('localVideo').srcObject;
        localVideo.getTracks().forEach((track) => {
          track.stop();
          track.enabled = false;
        });
      }
      document.getElementById('localVideo').srcObject = null;
      $(".local-video").removeClass('visible');

      if (document.getElementById('own-video').srcObject) {
        let localVideo = document.getElementById('own-video').srcObject;
        localVideo.getTracks().forEach((track) => {
          track.stop();
          track.enabled = false;
        });
      }

      this._localStream.getTracks().forEach((track) => {
        track.stop();
        track.enabled = false;
      });
      this._localStream = null;
      this._model.myWebcamStreamId = null;
      this.camAdaptor = null;
      clearInterval(this.interval);
      this.interval = false;
      this.streamsList = [];
      this.usersList = {};


      console.log('localVideo', document.getElementById('localVideo').srcObject);
      // if(this._model.publicStage){ //user stoped his cam stream but could be asked again to join public?
      //   console.log('this is public stage join? guestJoinedPublicStage: ', this._model.guestJoinedPublicStage);
      //   const lng = multiLanguagesController.languageObject;
      //   this._model.confirm(lng['join-public-stage'].text, () => {
      //     this._model.guestJoinedPublicStage = true;
      //     this._model.onNewUserJoinedPublicStage();
      //   }, { confirmBtnTxt: lng['yes-text'].text, cancelBtnTxt: lng['cancel-text'].text, dimmerClose: false });

      // }
    }

  }
  _stopScreenBroadcasting(streamId) {
    if (streamId === 'undefined' || streamId === undefined) {
      return;
    }

    $("#grid-view-option").addClass("disabled");

    if (this.screenAdaptor) {
      console.log('%c _stop ScreenBroadcasting screenAdaptor streamId:' + streamId, 'color: red; font-weight:bold; font-size:1em');
      if (!this.camAdaptor) {
        this.screenAdaptor.stop(streamId);
        this.screenAdaptor.closeWebSocket();
        this.screenAdaptor.closePeerConnection(streamId);
      } else {
        this.screenAdaptor.stop(streamId);
      }
      this.screenAdaptor = null;
      this._localScreenStream = null;
      this.screenObjId = null;
      clearInterval(this.interval2);
      this.interval2 = false;
      this._model.iShareScreen = false;
    }

  }

  _handleSignalingMessagesData = async (payload) => {
    // console.log('_handleSignalingMessagesData payload',payload);

    switch (payload.type) {

      case "user-started-webcamera":

        try {
          if (this._localStream === null) {
            return;
          }
          console.log(payload.userName, ' user-started-webcamera', payload);
          this.usersList[payload.webcamStreamId] = payload;
        } catch (err) {
          console.log('err while attempting user-started-webcamera', err);
        }
        break;

      case "user-stopped-1on1":

        try {
          console.log('user-stopped- 1on1', payload);
          console.log('%c STOPPED 1 on 1 scopeId: ' + payload.scopeId, 'color:red');




          if (this._local1on1Stream) {
            if (!this._model.activeOneOnOneCall) {
              var tracks = this._local1on1Stream.getTracks();
              tracks.forEach(track => track.enabled = false);
              $('.loading-spinner').removeClass('visible');
              this._local1on1Stream = null;
            }

          }

          if ($('#remoteVideo_' + payload.uuid).length) {
            console.log('remove video from video container');
            $('#remoteVideo_' + payload.uuid).remove();
          }

          if (this._localStream) { //TODO is screen
            console.log(' userId: ' + this.userProperties.userId + '  has _localStream');
            console.log(this._model.iStream.video);
            console.log('started1on1', this.started1on1);

            await this._setMyVideoEnabled(this._model.iStream.video, false);
            await this._setMyAudioEnabled(this._model.iStream.audio);
            // }, 1000);

          }



        } catch (err) {
          console.log(err);
        }
        break;


      case "user-started-screen":

        try {
          console.log('user-started-screen', payload);
          this.usersList[payload.screenStreamId] = payload;
          if (this._model.guestJoinedPublicStage) {
            //create player for user who already joined public stage when there was no streams
            this._model.onNewUserJoinedPublicStage();
          }

        } catch (err) {
          console.log('err while attempting user -started-screen', err);
        }
        break;
      case "user-stopped-screen":

        try {
          console.log('user-stopped-screen', payload);
          // this.usersList[payload.screenStreamId] = payload;

        } catch (err) {
          console.log('err while attempting user -stopped-screen', err);
        }
        break;

    }
  }

  _handleSignalingData = (payload) => {
    const peerUuid = payload.uuid;
    //console.log('handleSignalingData, peer ID: ', peerUuid)
    if (peerUuid === this._uuid || (payload.dest !== this._uuid && payload.dest !== 'all')) {
      console.log('return!!!');
      return;
    }

    if (!payload.scopeId || payload.scopeId !== this._currentScopeId) {
      return;
    }
    let objId = null;
    if (payload.objId) {
      objId = payload.objId;
    }

    if (payload.displayName && payload.dest === 'all') {
      console.log('%c dest all', 'padding:5px');
      console.log('payload', payload);
      this._setUpPeer(peerUuid, payload.displayName, false, payload.userId);
      // this._setUpPeer(peerUuid, payload.displayName, false, payload.userId, payload.userVideoOn);
      this._sendData({
        'displayName': this.userProperties.userName,
        'uuid': this._uuid,
        'userId': this.userProperties.userId,
        'dest': peerUuid
      });
    } else if (payload.stopConnection === true) {
      this._removePeer_Connection(payload);
    } else if (payload.displayName && payload.dest === this._uuid) {
      console.log('%c dest me', 'padding:5px');
      console.log('payload', payload);
      this._setUpPeer(peerUuid, payload.displayName, true, payload.userId);
    } else if (payload.sdp) {
      this._peerConnections[peerUuid].pc.setRemoteDescription(new RTCSessionDescription(payload.sdp))
        .then(() => {
          // console.log('payload.sdp.type:', payload.sdp.type);
          if (payload.sdp.type === 'offer') {
            this._peerConnections[peerUuid].pc.createAnswer().then(description => this._createdDescription(description, peerUuid)).catch(this._errorHandler);
          }
        })
        .catch(this._errorHandler);
    } else if (payload.ice) {
      this._peerConnections[peerUuid].pc.addIceCandidate(new RTCIceCandidate(payload.ice))
        .catch(this._errorHandler);
    }
  }

  _setUpPeer = async (peerUuid, displayName, initCall, userId) => {
    console.log('setUp Peer ', displayName, initCall, userId)
    try {
      const config = {
        iceServers: [
          {
            urls: 'stun:stun.l.google.com:19302',
            // 'stun:apprc.bagless.io:5349',
          },
          {
            urls: 'turn:apprc.bagless.io:5349',
            // urls: 'turn:apprc.bagless.io:5349?transport=udp',
            username: 'bagless',
            credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
          },
          {
            // urls: 'turn:apprc.bagless.io:5349',
            // urls: 'turn:apprc.bagless.io:5349?transport=udp',
            // username: 'bagless',
            // credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
            urls: 'turn:numb.viagenie.ca',
            credential: 'muazkh',
            username: 'webrtc@live.com'
          },
          {
            urls: "turn:openrelay.metered.ca:80",
            username: "openrelayproject",
            credential: "openrelayproject",
          },
          {
            urls: "turn:openrelay.metered.ca:443",
            username: "openrelayproject",
            credential: "openrelayproject",
          },

          // {
          //   urls: 'turn:apprc.bagless.io:5349',
          //   username: 'bagless',
          //   credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
          // }
          // {
          //   urls: [
          //     // 'stun:stun.l.google.com:19302',
          //     'stun:apprc.bagless.io:5349',
          //   ],
          // },
          // {
          //   // urls: 'turn:numb.viagenie.ca',
          //   // credential: 'muazkh',
          //   // username: 'webrtc@live.com'            
          //   urls: 'turn:apprc.bagless.io:5349',
          //   // urls: 'turn:apprc.bagless.io:5349?transport=udp',
          //   username: 'bagless',
          //   credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
          // }
        ],
        sdpSemantics: 'unified-plan',
      };

      this._peerConnections[peerUuid] = {
        displayName: displayName,
        userId: userId,
        pc: new RTCPeerConnection(config),
      };
      this._peerConnections[peerUuid].pc.onicecandidate = async (event) => await this._gotIceCandidate(event, peerUuid);
      this._peerConnections[peerUuid].pc.ontrack = async (event) => {
        await this._handleRemoteTrack(event, peerUuid, userId)
      };
      this._peerConnections[peerUuid].pc.oniceconnectionstatechange = () => this._checkPeerConnections();


      if (this._peerConnections[peerUuid].pc.addTrack) {
        if (this._localStream) {
          if (this.camAdaptor) { //TODO screenAdaptor
            console.log('addTrack this.started1on1', this.started1on1);
            // await this._setMyVideoEnabled(false, true);
          }
        }
        if (this._local1on1Stream) {
          this._local1on1Stream.getTracks().forEach((track) => {
            this._peerConnections[peerUuid].pc.addTrack(track, this._local1on1Stream);
          });
        }
      }
      if (initCall) {
        this._peerConnections[peerUuid].pc.createOffer()
          .then(description => this._createdDescription(description, peerUuid))
          .catch(this._errorHandler);
      }
    } catch (exception) {
      console.error('VRWebRtcController._setUp Peer()', exception);
    }
  }

  _handleRemoteTrack = async (event, peerUuid, userId) => {
    console.log('_handleRemoteTrack', userId);
    // console.log(this.peerUsers[userId].userName);

    if ($('#remoteVideo_' + userId).length) {
      // console.log('user has video on some chair, add busy icon overlay');
      $('#remoteVideo_' + userId).addClass('on-call');
    }
    let peerVideo = document.getElementById('peer-video-call');
    peerVideo.srcObject = event.streams[0];
    this._peerConnections[peerUuid].videoElement = peerVideo;
    $("#peer-avatar-call").hide();
    // replace red line with greeen line
    $(".call-line").addClass('active');
    $(".loading-spinner").removeClass('visible');
    // }

    if (this._currentScopeType === 'users' && !this.isMobile) {
      this.peerAudioLevelsAnalyzer = new AudioLevelsAnalyzer(event.streams[0], 'peer-audio-analyzer-one-on-one');
    }

    return;

  }


  _gotIceCandidate = async (event, peerUuid) => {
    if (event.candidate != null) {
      // console.log('gotIceCandidate', event.candidate)
      console.log('gotIceCandidate type: ', event.candidate.type)
      if (event.candidate.type == "srflx") {
        console.log("The STUN server is reachable!");
        console.log(`   Your Public IP Address is: ${event.candidate.address}`);
      }
      // If a relay candidate was found, notify that the TURN server works!
      if (event.candidate.type == "relay") {
        console.log("The TURN server is reachable !");
      }

      this._sendData({
        'ice': event.candidate,
        'uuid': this._uuid,
        'userId': this.userProperties.userId,
        'dest': peerUuid,
      });
    }
  }

  sendErrorToLogs(err) {
    this._sendSignalData({
      'error': err
    });
  }


  _checkPeerConnections = () => {
    //console.log('checkPeerConnections')
    $.each(this._peerConnections, (peerUuid, connection) => {
      try {
        var state = this._peerConnections[peerUuid].pc.iceConnectionState;
        //console.log('peer connection state (peerUuid, state): ', peerUuid, state)
        if (state === 'failed' || state === 'closed' || state === 'disconnected') {
          console.log('state: ', state);
          this._removePeerConnection(peerUuid);
          //console.error(state, peerUuid, this._peerConnections[peerUuid])
        }
      } catch (exception) {
        console.error('_checkPeerConnections', exception);
      }
    });
  }


  _generateLabelElement = (name, userId = null) => {
    //console.log('generateLabelElement')
    var userLabel = document.createElement('div');
    userLabel.appendChild(document.createTextNode(name));
    userLabel.setAttribute('class', 'videoLabel');
    userLabel.setAttribute('data-user-name', htmlEscaper(name));

    if (userId) {
      userLabel.setAttribute('data-user-id', htmlEscaper(userId));
    }

    return userLabel;
  }

  _errorHandler = (error) => {
    console.error(error);
  }

  _removeTrack = () => {
    console.log('_removeTrack');

    if (this._localStream) {
      this._localStream.getTracks().forEach((track) => {

        //if(!userScreenShareOn){
        //this._peerConnections[peerUuid].pc.removeTrack(track, this._localStream);
        //}
      });
    }
    if (JSON.stringify(this._peerConnections) !== JSON.stringify({})) {
      console.log(this._peerConnections)
      for (const property in this._peerConnections) {
        const sender = this._peerConnections[property].pc.getSenders().find(s => {
          //s.track && s.track.kind === withTrack.kind
          console.log('s.track', s.track);
          //if (sender) {
          // console.log('sender', sender);
          //s.track.removeTrack(s);
          //}
        });
        if (sender) {
          //console.log('remove sender', sender);
          console.log('%c remove sender', 'background:orange; color:black; padding:5px');
          console.log('pc', this._peerConnections[property].pc);
          this._peerConnections[property].pc.removeTrack(sender);
          this._localScreenStream.removeTrack(sender);
          //sender.removeTrack(withTrack);
          if (this._localScreenStream !== null) {

            this._localScreenStream.getTracks().forEach((track) => {
              // console.log(track);
              console.log('%c local _screenStream', 'background:pink; color:black; padding:5px');
              // this._peerConnections[peerUuid].pc.addTrack(track, this._localScreenStream);
              this._peerConnections[peerUuid].pc.removeTrack(sender);
            });
            console.log('____this._localScreenStream', this._localScreenStream);
            $(".localVideoWrapper").hasClass('grid-mode') && this._model.calculateGridDimensions();
          }
        }
        this._localScreenStream = null;

      }
    }
    //$(".loading-spinner").removeClass('visible');
    this._model.iShareScreen = false;
  }


  _formatStreamId = (id) => {
    //firefox adding brackets
    let result;
    if (id.charAt(0) === "{") {
      result = id.slice(1, -1);
    } else {
      result = id;
    }
    return result;
  }



  join_Room_WithCam = async (roomId, streamId) => {
    if (this.camAdaptor !== null) {
      let id = this._formatStreamId(streamId);
      if (id) {
        console.log('%c join_Room_WithCam id: ' + id, 'background:yellowgreen');
        this.camAdaptor.joinRoom(roomId, id, "legacy");
        this.camAdaptor.publish(id);
      }
    }
  }
  join_Room_WithScreen = (roomId, streamId) => {

    if (this.screenAdaptor !== null) {
      let id = this._formatStreamId(streamId);
      this.screenAdaptor.joinRoom(roomId, id, "legacy");
      this.screenAdaptor.publish(id);
    }
  }


  createRemoteScreenVideo = (streamId) => {
    console.log('createRemoteScreenVideo');
    let user;
    if (this.usersList[streamId] !== undefined) {
      user = this.usersList[streamId];
    }
    if (user == null) {
      //then its screen share
      user = this._socket.getUserScreenData(streamId);
    }
    if (user != null) {
      this._createRemoteScreenShare(user.screenStreamId, user.userId, user.userAvatarUrl, user.userName, user.userScreenShareOn, user.objId);
    }
  }


  createRemoteWebcamVideo = (streamId) => {
    let user;
    // console.log('createRemoteWebcam Video', streamId);

    user = this._socket.getUserWebcamData(streamId);

    if (user == null) {
      //   //then its screen share
      user = this._socket.getUserScreenData(streamId);
    }
    if (user.webcamStreamId !== null) {
      this._createRemoteWebCam(user.webcamStreamId, user.userId, user.userAvatarUrl, user.userName, user.userVideoOn);
    }

  }

  _createRemoteScreenShare = (streamId, userId, avatar, displayName, userScreenShareOn, objId) => {
    //screenShareVideo_
    if ($(`#screenShareVideo_${streamId}`).length > 0) {
      // console.log('_createRemoteScreenShare return it exists!', displayName);
      return;
    }
    console.log('_createRemoteScreenShare', displayName);
    if (streamId == null) {
      // console.log('_createRemoteScreenShare streamId null');
      return;
    }

    var vidContainer = document.createElement('div');
    vidContainer.setAttribute('id', 'remoteScreenShareVideo_' + userId);
    vidContainer.setAttribute('class', 'video-wrapper square');

    var videoElement = document.createElement('video');
    videoElement.setAttribute('autoplay', true);
    videoElement.setAttribute('playsinline', true);
    videoElement.setAttribute('id', `screenShareVideo_${streamId}`);
    vidContainer.appendChild(videoElement);

    let peerImg = document.createElement('img');
    peerImg.innerHTML = `<img src="${avatar}" alt="Avatar" class="avatar-img ${userId}"`;
    vidContainer.appendChild(peerImg);

    vidContainer.appendChild(this._generateLabelElement(displayName, userId));

    $('#localVideoContainer').append(vidContainer);

    videoElement.addEventListener('loadedmetadata', () => {
      this._model.isSomeoneScreenSharing = true;
      let userScreenShareOn = true;
      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SOME_SCREEN_SHARE_STARTED, data: { userId, userScreenShareOn, objId, streamId } });

    });

  }


  _createRemoteWebCam = (streamId, userId, avatar, displayName, userVideoOn) => {

    // console.log('_createRemoteWeb Cam avatar:',avatar);

    if (streamId == null) {
      return;
    }
    if ($(`#remoteVideo${streamId}`).length > 0) {
      console.log('_createRemoteWeb Cam return it exists!', displayName, streamId);
      return;
    }

    console.log('_createRemoteWeb Cam for ', displayName);
    if (!this.publicAdaptor) { //public got another method to getStreamInfo
      this.getStreamSize(streamId);
    }
    var vidContainer = document.createElement('div');
    vidContainer.setAttribute('id', 'remoteVideo_' + userId);
    if (!userVideoOn) {
      vidContainer.setAttribute('class', 'video-wrapper hidden');
    } else {
      vidContainer.setAttribute('class', 'video-wrapper');
    }

    var videoElement = document.createElement('video');
    videoElement.setAttribute('autoplay', true);
    videoElement.setAttribute('playsinline', true);
    videoElement.setAttribute('id', `remoteVideo${streamId}`);
    vidContainer.appendChild(videoElement);

    let peerImg = document.createElement('img');
    peerImg.setAttribute('src', avatar);
    peerImg.setAttribute('class', `avatar-img ${userId}`);
    // peerImg.innerHTML = `<img src="${avatar}" alt="Avatar" class="avatar-img ${userId}"`;
    vidContainer.appendChild(peerImg);

    const icon = document.createElement('span');
    icon.textContent = 'phone_in_talk';
    icon.setAttribute('class', 'material-icons-outlined on-call-icon');
    vidContainer.appendChild(icon);

    vidContainer.appendChild(this._generateLabelElement(displayName, userId));

    $('#localVideoContainer').append(vidContainer);

    videoElement.addEventListener('loadedmetadata', () => {
      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SOME_VIDEO_STARTED, data: { userId, userVideoOn, streamId } });
      this._model.attachSinkId(videoElement, $(".speakerSelect").val());

    });
  }

  startPlayStream = (item) => {

    if (this.screenAdaptor && this._localScreenStream.id == item) {
      // console.log('my screen stream');
      return;
    }

    if (this.camAdaptor) {
      console.log('%c startPlay Stream camAdaptor', 'background: pink');
      if (this._localStream.id != item) {
        this.camAdaptor.play(item);
      }
    }
  }
  startPlayStreamScreen = (item) => {

    if (this.camAdaptor) {
      //Let cam adaptor be main stream player
      // console.log('my cam stream');
      return;
    }
    if (this.screenAdaptor) {
      console.log('%c startPlayStreamScreen screenAdaptor', 'background: yellowgreen');
      if (this._localScreenStream.id != item) {
        this.screenAdaptor.play(item);
      }
    }

  }

  getStreamSize = async (streamId) => {
    //this is called to get info about video w and h
    // console.log('getStreamSize');
    if (this.camAdaptor) {
      this.camAdaptor.getStreamInfo(streamId)
    }
    if (this.screenAdaptor) {
      this.screenAdaptor.getStreamInfo(streamId)
    }

  }

  //initCameraWebRTCAdaptor = async (mediaConstraints, scopeType, withCamera, withSound, scopeId, scopeDisplayName) => {
  initCameraWebRTCAdaptor = async (stream, mediaConstraints, scopeType, withCamera, withSound, scopeId, scopeDisplayName) => {

    if (this.publicAdaptor) {
      console.log('user has public adaptor, close connection! iPlayPublicStream, guestJoinedPublicStage', this._model.iPlayPublicStream, this._model.guestJoinedPublicStage);
      this.publicAdaptor.closeWebSocket();
      this.publicAdaptor.closePeerConnection();
      this.publicAdaptor = null;
    }
    let publishStreamId;
    let userId = this.userProperties.userId;
    let userName = this.userProperties.userName;
    const self = this;
    let streamWidth = 0;
    let streamHeight = 0;
    let roomID = $("#roomId").val();
    let streamId = null;


    self.camAdaptor = new WebRTCAdaptor({
      websocket_url: websocketURL,
      viewerInfo: this._model.config.userName, // TODO for refactoring add full user object here, get rid of socoket events dependencies 
      mediaConstraints: mediaConstraints,
      peerconnection_config: pc_config,
      sdp_constraints: sdpConstraints,
      localVideoId: "localVideo",
      isPlayMode: false,
      localStream: stream,
      debug: false,
      dataChannelEnabled: false,
      callback: async (info, obj) => {
        // callback: function (info, obj) {
        // console.log(info, obj);
        if (info == "initialized") {
          // console.log(info, obj);
          if (self.camAdaptor.localStream) {
            // self._localStream = self.camAdaptor.localStream;
            streamId = self._formatStreamId(self.camAdaptor.localStream.id);//self.camAdaptor.localStream.id;
            self._model.myWebcamStreamId = streamId;
            await self.join_Room_WithCam(roomID, streamId);
            $(".local-video").addClass('visible');

          }
        } else if (info == "joinedTheRoom") {
          // console.log(info, obj);
          let room = obj.ATTR_ROOM_NAME;
          self.roomOfStream[obj.streamId] = room;
          // console.log("joined the room: "+ self.roomOfStream[obj.streamId]);
          // publishStreamId = obj.streamId
          if (obj.streams != null) { // check if empty
            obj.streams.forEach(function (item) {
              // console.log("Stream joined with ID: " + item);
              // self.startPlayStream(item);// (item, null, roomID);
              self.camAdaptor.play(item);
            });
            self.streamsList = obj.streams;
          }

        } else if (info == "publish_started") {
          // console.log(info);
          console.log(info, obj);
          await self.getStreamSize(obj.streamId);
          self.startPlay(obj.streamId);

        } else if (info == "streamInformation") {
          console.log(info, obj);
          streamWidth = obj.streamInfo[0].streamWidth;
          streamHeight = obj.streamInfo[0].streamHeight;
          let elem = document.getElementById(`remoteVideo${obj.streamId}`);
          if (elem) {
            elem.setAttribute('stream-width', streamWidth);
            elem.setAttribute('stream-height', streamHeight);
          }
          if (streamId == obj.streamId) {
            document.getElementById('localVideo').setAttribute('stream-width', streamWidth);
            document.getElementById('localVideo').setAttribute('stream-height', streamHeight);

            await self._setMyVideoEnabled(withCamera, false);
            await self._setMyAudioEnabled(withSound);

            await self._model.attachSinkId(document.getElementById('localVideo'), $(".speakerSelect").val());
            self._model.playAudioNotification('enterSeat');

            $("#my-own-video-wrapper").toggleClass('hidden', !withCamera);
            self._model.hideMediaDevices && self._model.getMediaDevices(); //TODO do I need this?


            self._sendSignalData({
              'type': 'user-started-webcamera',
              'userName': self.userProperties.userName,
              'userId': self.userProperties.userId,
              'userAvatarUrl': self.userProperties.userAvatarUrl,
              'webcamStreamId': streamId//self._formatStreamId(self._localStream.id)
            });
          }
        }
        else if (info == "publish_finished") {
          console.log(info, obj);
          self.endStreaming(self.streamsList);
        }
        else if (info == "newStreamAvailable") {
          console.log(info, obj);
          await self.playVideo(obj);
        }
        else if (info == "available_devices") {
          if (self._localStream && self._localStream != self.camAdaptor.localStream) { //TODO check events when device replaced
            self._localStream = self.camAdaptor.localStream;
          }
        }
        else if (info == "roomInformation") {
          // console.log(info, obj);
          for (let str of obj.streams) {
            if (!self.streamsList.includes(str)) {
              self.startPlayStream(str);
            }
          }
          for (let str of self.streamsList) {
            if (!obj.streams.includes(str)) {
              self.removeRemoteVideo(str);
            }
          }
          self.streamsList = obj.streams;
          self.checkVideoTrackStatus(self.streamsList); //camAdaptor
        }
        else if (info == "play_finished") {
          console.log(info, obj);
          self.removeRemoteVideo(obj.streamId);
        }
        else if (info == "updated_stats") {
          console.log("Average outgoing bitrate " + obj.averageOutgoingBitrate + " kbits/sec"
            + " Current outgoing bitrate: " + obj.currentOutgoingBitrate + " kbits/sec");
        } else if (info == "ice_connection_state_changed") {
          console.log("iceConnectionState Changed: ", JSON.stringify(obj));
        } else if (info == "closed") {
          //console.log("Connection closed");
          if (typeof obj != "undefined") {
            console.log("Connecton closed: " + JSON.stringify(obj));
            // if(document.getElementById('localVideo').srcObject){
            //   let localVideo = document.getElementById('localVideo').srcObject;
            //   localVideo.getTracks().forEach((track) => {
            //     track.stop();
            //     track.enabled = false;
            //   });
            //   document.getElementById('localVideo').srcObject = null;
            // }
            // if(this._localStream){
            //   this._localStream.getTracks().forEach((track) => {
            //     track.stop();
            //     track.enabled = false;
            //   });

            //   this._localStream = null;
            // }

          }
        }
      },
      callbackError: function (error, message) {
        //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
        console.log("error callback: " + JSON.stringify(error));
        //publishTimeoutError //user turnes on wifi
        var errorMessage = JSON.stringify(error);
        if (typeof message != "undefined") {
          errorMessage = message;
        }
        var errorMessage = JSON.stringify(error);
        // console.log(error);
        // console.log(error.indexOf("already_playing"));
        if (error == "already_playing") {
          return;
          // errorMessage = "Camera or Mic are not found or not allowed in your device";
        }
        //WebSocketNotConnected //TODO user turnes off wifi 
        // if (error == "WebSocketNotConnected") {

        // }
        console.error(errorMessage);
      }
    });
  }

  endStreaming = (streams) => {
    if (!this._localStream && !this._localScreenStream) {
      console.log('end Streaming', streams);

      for (let i = 0; i < streams.length; i++) {
        const stream = streams[i];
        this.removeRemoteVideo(stream)
      }
      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_I_STOP_BROADCASTING });

    }
  }

  one_on_one_disableStreams = async () => {
    if (this.camAdaptor) { // TODO screenAdaptor
      this.camAdaptor.turnOffLocalCamera();
      this.camAdaptor.muteLocalMic();
    }
  }

  initScreenWebRTCAdaptor = async (stream, mediaConstraints) => {

    // var websocketURL = "wss://bagless-media-server.com:5443/WebRTCAppEE/websocket";
    const whatToStream = $('input[name="whatToStream"]:checked').val();
    const isScreen = whatToStream === 'screen';

    let publishStreamId;
    const self = this;

    self.screenAdaptor = new WebRTCAdaptor({
      websocket_url: websocketURL,
      mediaConstraints: {
        video: isScreen ? 'screen' : $("#startStreamWithVideo2").prop("checked"),
        audio: isScreen ? false : $("#startStreamWithAudio2").prop("checked")
      },
      peerconnection_config: pc_config,
      sdp_constraints: sdpConstraints,
      localVideoId: "initial-screen-share-video",
      isPlayMode: false,//playOnly, If it's true, user does not publish stream. It only play streams in the room.
      localStream: stream,
      debug: false,
      dataChannelEnabled: false,
      callback: function (info, obj) {
        // console.log('info',info);
        // console.log('obj',obj);
        if (info == "initialized") {
          const roomID = $("#roomId").val();
          // console.log('roomID:', roomID);
          self.join_Room_WithScreen(roomID, self._localScreenStream.id);
        } else if (info == "joinedTheRoom") {
          console.log(info, obj);
          let room = obj.ATTR_ROOM_NAME;
          self.roomOfStream[obj.streamId] = room;
          publishStreamId = obj.streamId
          if (obj.streams != null) {
            obj.streams.forEach(function (item) {
              console.log("Stream joined with ID: " + item);
              self.startPlayStreamScreen(item);// (item, null, roomID);
            });
            self.streamsList = obj.streams;
          }

        } else if (info == "publish_started") {
          console.log(info, obj);
          self.startPlay(obj.streamId);
        } else if (info == "publish_finished") {
          console.log(info, obj);
          self.endStreaming(self.streamsList);
        }
        else if (info == "newStreamAvailable") { //screenAdaptor
          console.log(info, obj);
          self.playVideo(obj);
        }
        else if (info == "play_finished") {
          console.log(info, obj);
          self.removeRemoteVideo(obj.streamId);
        }
        else if (info == "roomInformation") { //screenAdaptor
          for (let str of obj.streams) {
            if (!self.streamsList.includes(str)) {
              self.startPlayStreamScreen(str);
            }
          }
          for (let str of self.streamsList) {
            if (!obj.streams.includes(str)) {
              self.removeRemoteVideo(str);
            }
          }
          self.streamsList = obj.streams;
          self.checkVideoTrackStatus(self.streamsList, 'screenAdaptor');

        }

      },
      callbackError: function (error, message) {
        //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError

        console.log("error callback: " + JSON.stringify(error));
        var errorMessage = JSON.stringify(error);
        if (typeof message != "undefined") {
          errorMessage = message;
        }
        var errorMessage = JSON.stringify(error);
        console.error(errorMessage);
      }
    });
  }

  startScreenShare = async () => {

    try {
      const whatToStream = $('input[name="whatToStream"]:checked').val();

      if (whatToStream === 'screen') {
        this.screenShareEl.srcObject = await navigator.mediaDevices.getDisplayMedia({
          video: true,
          audio: true,
        });
      } else {
        this.screenShareEl.srcObject = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: $("#startStreamWithVideo2").prop("checked") ? { exact: $(".cameraSelect").val() } : undefined },
          audio: { deviceId: $("#startStreamWithAudio2").prop("checked") ? { exact: $(".microphoneSelect").val() } : undefined },
        });
      }
      this._localScreenStream = this.screenShareEl.srcObject;

    } catch (err) {
      console.error("Error start Screen Share: " + err);
      this._model.alert('error', err, null);
      //this.model.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
    }
  }

  checkVideoTrackStatus = (streamsList) => {

    streamsList.forEach(function (item) {
      var video = document.getElementById("remoteVideo" + item);
      if (video != null && !video.srcObject.active) {
        this.playVideo(item);
      }
    });

  }

  playVideo = async (obj) => {

    console.log('%c play Video', 'background:pink');
    // console.log('obj',obj);
    let user, video;
    user = this._socket.getUserScreenData(obj.streamId);
    if (user != null) {
      console.log('this is SCREEN stream id from user ', user);
      video = document.getElementById("screenShareVideo_" + obj.streamId);
      if (video === null) {
        this.createRemoteScreenVideo(obj.streamId);
        video = document.getElementById("screenShareVideo_" + obj.streamId);
      }
      video.srcObject = obj.stream;
    }

    user = this._socket.getUserWebcamData(obj.streamId);
    if (user != null) {
      console.log('this is WEBCAM stream id from user ', user.userName, user);

      if (this.userProperties.userId == user.userId) {
        // console.log('THIS IS ME');
      } else {

        video = document.getElementById("remoteVideo" + obj.streamId);
        if (video === null) {
          this.createRemoteWebcamVideo(obj.streamId);
          video = document.getElementById("remoteVideo" + obj.streamId);
          console.log('video', video);
          if (video == null) {
            console.log('no video, just avatar', obj.stream);
          } else {
            video.srcObject = obj.stream;
          }
        } else {
          //remote video still exists after user stand up
          video.srcObject = obj.stream;
        }

      }
    }




  }

  removeRemoteVideo = async (streamId) => {

    if (this._currentScopeType == 'users') {
    } else {
      //If both adaptors
      if (this.camAdaptor && this.screenAdaptor) {
        if (streamId == this._localStream.id) {
          return;
        }
        if (streamId == this._localScreenStream.id) {
          return;
        }
      }

      console.log('%c removeRemoteVideo ' + streamId, 'color:red');
      var video = document.getElementById("remoteVideo" + streamId);
      if (video != null) {
        $("#remoteVideo" + streamId).parent().remove();
        video.srcObject = null;
      }
      var screen = document.getElementById("screenShareVideo_" + streamId);
      if (screen != null) {
        $("#screenShareVideo_" + streamId).parent().remove();
        screen.srcObject = null;
      }
      this.streamsList = this.streamsList.filter(item => item !== streamId);

    }
  }

  startPlay = (publishStreamId) => {
    const roomID = $("#roomId").val();
    if (this.camAdaptor) {
      if (!this.interval) { //TODO&& this._currentScopeType != 'users' 
        // console.log('%c startPlay camAdaptor', 'background: #0fd395');
        this.interval = setInterval(() => {
          this.camAdaptor.getRoomInfo(roomID, publishStreamId);
        }, 3000);
      }
    } //else if (this.screenAdaptor) {
    if (this.screenAdaptor) {
      if (!this.interval2) {
        this.interval2 = setInterval(() => {
          if (this.screenAdaptor) {
            this.screenAdaptor.getRoomInfo(roomID, publishStreamId);
          }
        }, 3000);
      }

    }
  }


  getPublicStreamInfo = async (streamId) => {
    try {
      if (this.publicAdaptor) {
        await this.publicAdaptor.getStreamInfo(streamId);
      }
    } catch (error) {
      console.log(error);
    }
  }
  updatePublicStreamList = async (streamId) => {

    if (this.streamsList.length > 0) {
      for (let i = 0; i < this.streamsList.length; i++) {
        if (this.streamsList[i] !== streamId) {
          this.streamsList.push(streamId);
        }
      }
    } else {
      this.streamsList.push(streamId);
    }
    console.log('updatePublicStreamList this.streamsList', this.streamsList);

  }

  initPublicAdaptor = async (streamId, videoId, userId, userVideoOn, userScreenShareOn, objId, publicCallback) => {

    console.log('%c initPublic Adaptor for ' + this._model.config.userName, 'background:yellow; color:black');
    console.log(streamId, videoId, userId, userVideoOn, userScreenShareOn, objId);

    if (this.publicAdaptor) {
      console.log('EXISTS!');
      // console.log(this.publicAdaptor);
    }
    this._model.iPlayPublicStream = true;

    let iceConnected = false;
    // console.log('this.publicObjects',this.publicObjects);
    let publicLocalAdaptor = null;
    const self = this;
    let streamWidth = 0;
    let streamHeight = 0;

    publicLocalAdaptor = new WebRTCAdaptor({
      websocket_url: websocketURL,
      mediaConstraints: publicMediaConstraints,
      peerconnection_config: pc_config,
      sdp_constraints: publicsdpConstraints,
      viewerInfo: this._model.config.userName,
      remoteVideoId: videoId,
      isPlayMode: true,
      debug: false,
      callback: async (info, obj) => {
        // console.log(info,obj);
        if (info == "initialized") {
          iceConnected = false;
          if (streamId) {
            self.publicAdaptor = publicLocalAdaptor;
            //await self.getPublicStreamInfo(streamId);
            self.getPublicStreamInfo(streamId);

          }
        }
        else if (info == "streamInformation") {
          // console.log(info,obj);
          streamWidth = obj.streamInfo[0].streamWidth;
          streamHeight = obj.streamInfo[0].streamHeight;

          let elemCam = document.getElementById(`remoteVideo${obj.streamId}`);
          if (elemCam) {
            elemCam.setAttribute('stream-width', streamWidth);
            elemCam.setAttribute('stream-height', streamHeight);
          }
          let elemScreen = document.getElementById(`screenShareVideo_${obj.streamId}`);
          if (elemScreen) {
            elemScreen.setAttribute('stream-width', streamWidth);
            elemScreen.setAttribute('stream-height', streamHeight);
          }
          // console.log('call play');
          // self.updatePublicStreamList(streamId);
          publicLocalAdaptor.play(streamId);
          // self.publicAdaptor.play(streamId); 
          $("#grid-view-option").removeClass("disabled");
        }
        else if (info == "play_started") {
          console.log(info, obj);
          self.updatePublicStreamList(obj.streamId);
        }
        else if (info == "play_finished") {
          //leaved the stream
          console.log(info, obj);
          // self.updatePublicStreamList(obj.streamId);
          await self.removeRemoteVideo(obj.streamId);

          self.publicAdaptor.stop(obj.streamId);
          self.publicAdaptor.closePeerConnection(obj.streamId);
          self.publicAdaptor.closeWebSocket();
          if (self.streamsList.length > 0) {
            //TODO
          } else {
            // self.publicAdaptor.closePeerConnection(obj.streamId);
            self._model.iPlayPublicStream = false;

          }

          console.log(self.streamsList);

        }
        else if (info == "newStreamAvailable") {
          console.log(info, obj);
          self.publicAdaptor.getStreamInfo();
          await self.playVideo(obj);
        }
        else if (info == "roomInformation") {

        }
        else if (info == "closed") {
          //console.log("Connection closed");
          if (typeof obj != "undefined") {
            console.log("Connecton closed: " + JSON.stringify(obj));
            self.stopPublicPlayer(streamId);
          }
        }

        else if (info == "ice_connection_state_changed") {
          console.debug("ice connection state changed to " + obj.state);
          if (obj.state == "connected" || obj.state == "completed") {
            //it means the ice connection has been established
            iceConnected = true;
          }
        }


      },
      // callbackError: function (error) {
      callbackError: async (error) => {
        console.log("error callback: " + JSON.stringify(error));
        if (error == "already_playing") {
          return;
        }
        if (error == "noStreamNameSpecified") {

          return;
        }
        if (error == "no_stream_exist") {
          if (typeof publicCallback != "undefined") {
            console.log('call publicCallback', streamId, objId);
            // await this.getPublicStreamInfo(streamId);
            this.getPublicStreamInfo(streamId);
            // self.publicCallback(streamId, videoId, userId, userVideoOn, userScreenShareOn, objId, publicCallback);
          }
        }
      }
    });
  }

  stopPublicPlayer = (streamId) => {
    console.log('%c stopPublicPlayer ' + streamId, 'color:red');
    this._model.iPlayPublicStream = false;
    if (this.publicAdaptor) {
      this.publicAdaptor.closeWebSocket();
      clearInterval(this.publicInterval);
      this.publicInterval = false;
      this.streamsList = [];
      // streamId && this.publicAdaptor.closePeerConnection(streamId);
    }
    this.publicAdaptor = null;
    console.log(this.publicAdaptor);
  }

  publicCallback = async (streamId, videoId, userId, userVideoOn, userScreenShareOn, objId, publicCallback) => {

    setTimeout(async () => {
      if (!this.publicAdaptor) {
        this.publicAdaptor = this.initPublicAdaptor(streamId, videoId, userId, userVideoOn, userScreenShareOn, objId, publicCallback);
      } else {
        console.log(this.publicAdaptor);
      }
    }, 3000);
  }

  init = (socket) => {
    this._socket = socket.data;
    this.videoElement = $('body').find("#localVideo");
    this.videoLabel = $('body').find(".videoLabel");

    this.localVideoContainer = $(document).find('#localVideoContainer');



  }


  start = async (scopeType, scopeId = 1, scopeDisplayName = 'test scene', withCamera = true, withSound = true, constraints, removeElement = null, unique_id = null) => {

    if (scopeType === 'screenShare') {

      if (this.screenShareEl.srcObject) {

        let tracks = this.screenShareEl.srcObject.getTracks();

        tracks.forEach(track => track.stop());
        this.screenShareEl.srcObject = null;
      }

      this._localScreenStream = null;

      this._currentScopeType = scopeType;
      this._currentScopeId = scopeId;
      this._currentScopeDisplayName = scopeDisplayName;

      const loadedMetaDataScreenCallBack = async () => {



        console.log('loadedMetaDataScreenCallBack');
        this.screenShareEl.removeEventListener('loadedmetadata', loadedMetaDataScreenCallBack);
        // console.log('this._localScreenStream',this._localScreenStream);
        await this.initScreenWebRTCAdaptor(this._localScreenStream);
        this._model.iShareScreen = true;
        this._model.isSomeoneScreenSharing = true;
        let myVideoElInGrid = document.getElementById('screen-share-video');
        myVideoElInGrid.srcObject = this.screenShareEl.srcObject;
        this.startedScreenShare = true;
        this.userProperties.userScreenShareOn = true;
        this.userProperties.objId = this.screenObjId;//unique_id;
        let screen_StreamId = this._formatStreamId(this._localScreenStream.id);
        console.log('%c I start screenshare streamID: ' + screen_StreamId, 'background:greenyellow;');
        this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_USER_STARTED_SCREEN_SHARE, data: { scopeType, withCamera: true, withSound: false, scopeId, scopeDisplayName, peerInfo: this.peerInfo, unique_id: this.screenObjId, userScreenShareOn: true, screenStreamId: screen_StreamId } });

        this._sendSignalData({
          'type': 'user-started-screen',
          'userName': this.userProperties.userName,
          'userId': this.userProperties.userId,
          'userAvatarUrl': this.userProperties.userAvatarUrl,
          'screenStreamId': screen_StreamId,
          'objId': this.screenObjId
        });
      }

      this.screenShareEl.addEventListener('loadedmetadata', loadedMetaDataScreenCallBack);
      this.screenShareEl.addEventListener('ended', (event) => {
        console.log('ended!');
      });
      this.startScreenShare();

    }

    if (scopeType === 'scene') { //webcam 

      if (!navigator.mediaDevices.getUserMedia) {
        return alert('Ihr Gerät unterstützt keine Video/Audio Übertragung');
      }

      this._localStream = null;
      this._currentScopeType = scopeType;
      this._currentScopeId = scopeId;
      this._currentScopeDisplayName = scopeDisplayName;

      try {

        let mediaConstraints = {
          video: { deviceId: { exact: constraints.cameraDevice } },
          audio: { deviceId: { exact: constraints.microphoneDevice } },
        };



        this._localStream = await navigator.mediaDevices.getUserMedia(mediaConstraints);

        let video = document.querySelector('video#localVideo');
        video.srcObject = this._localStream;

        await this.initCameraWebRTCAdaptor(this._localStream, mediaConstraints, scopeType, withCamera, withSound, scopeId, scopeDisplayName);





        // await this.initCameraWebRTCAdaptor(mediaConstraints, scopeType, withCamera, withSound, scopeId, scopeDisplayName);

      } catch (err) {
        this._errorHandler(err);
      }

    }

    if (scopeType === 'users') {

      this._stop(true, false); //TODO check if already on a call should dispatch?
      console.log('start = 1 on 1');

      if (!navigator.mediaDevices.getUserMedia) {
        return alert('Ihr Gerät unterstützt keine Video/Audio Übertragung');
      }

      if (this._localScreenStream) {
        $('#stopScreenShare').trigger('click');
        // let screenId = this._formatStreamId(this._localScreenStream.id);
        // this._stopScreenBroadcasting(screenId); //not removing chrome screen share control window 
        // this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_STOP_SCREEN_SHARE });
      }

      this._currentScopeType = scopeType;
      this._currentScopeId = scopeId;
      this._currentScopeDisplayName = scopeDisplayName;

      let myOneOnOne = document.getElementById('own-video-call');

      navigator.mediaDevices.getUserMedia({
        video: { deviceId: constraints.cameraDevice ? { exact: constraints.cameraDevice } : undefined },
        audio: { deviceId: constraints.microphoneDevice ? { exact: constraints.microphoneDevice } : undefined },
      })
        .then(stream => {

          this._local1on1Stream = stream;
          myOneOnOne.srcObject = stream;

          if (!this.isMobile) {
            this.myAudioLevelsAnalyzer = new AudioLevelsAnalyzer(stream, 'my-audio-analyzer-one-on-one');
          }

          const onLoaded1on1MetadataCallback = () => {

            this._model.attachSinkId(document.getElementById('own-video-call'), $(".speakerSelect").val());
            this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_USER_STARTED_VIDEO, data: { scopeType, withCamera, withSound, scopeId, scopeDisplayName, peerInfo: this.peerInfo } });

            $("#my-own-video-wrapper").addClass('hidden');
            $('#my-own-video-wrapper').addClass('on-1on1-call');

            this.removeNotification(removeElement);
            $("#own-avatar-call").hide();

            this._model.dispatchEvent({ type: SCENE_INTERACTION.USER_VIDEO_STATE_CHANGED, data: { 'userVideoOn': false, 'on1on1Call': true } });
            document.getElementById('own-video-call').removeEventListener('loadedmetadata', onLoaded1on1MetadataCallback);
          }

          myOneOnOne.addEventListener('loadedmetadata', onLoaded1on1MetadataCallback);
          this._model.hideMediaDevices && this._model.getMediaDevices(); //TODO check what is this doing
          this.started1on1 = true;
        })
        .catch(err => {
          this._errorHandler(err);
          this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_FAILED_TO_START_USER_VIDEO });
        })
        .then(() => {

          this._sendData({
            'displayName': this.userProperties.userName,
            'uuid': this._uuid,
            'userId': this.userProperties.userId,
            'dest': 'all'
          });
        })
        .catch(this._errorHandler);

    }

    $("#grid-view-option").removeClass("disabled");

  }

  removeNotification(removeElement) {
    removeElement !== null && $(`.${removeElement}`).remove();
    $('#notifications_holder').removeClass('expanded');
    const activeCalls = $("#video_notifications > .call_notification").length;
    $('#notification_toggle_button').attr('data-count', activeCalls);
    !activeCalls && $('#notification_toggle_button').hide();
  }



  _camOn = async (id) => {
    try {
      if (id) {
        this.camAdaptor.turnOnLocalCamera(id);
        // setTimeout( async () => { //Uncaught (in promise) DOMException: Could not start video source
        //   // console.log('now');
        //   // this.camAdaptor.turnOnLocalCamera();
        // }, 1000);
      } else {
        this.camAdaptor.turnOnLocalCamera();
      }
    } catch (exception) {
      console.error('_camOn', exception);
    }
  }
  _camOff = async (id) => {
    if (id) {
      this.camAdaptor.turnOffLocalCamera(id);
    } else {
      this.camAdaptor.turnOffLocalCamera(this.camAdaptor.publishStreamId);
    }
  }

  _setMyVideoEnabled = async (state, isBusy) => {
    try {
      if (this.camAdaptor) {
        console.log('_cam Control state, isBusy: ', state, isBusy);
        if (state) {
          if (this.camAdaptor) {
            await this._camOn(this.camAdaptor.publishStreamId);
          }
          $("#toggleVideoTrack p").text($trans('turn-cam-off-text'));
          $("#toggleVideoTrack p").attr('data-lang', 'turn-cam-off-text');
          $("#toggleVideoTrack span").html("videocam");
        } else {
          if (this.camAdaptor) {
            await this._camOff(this.camAdaptor.publishStreamId);
          }
          $("#toggleVideoTrack p").text($trans('turn-cam-on-text'));
          $("#toggleVideoTrack p").attr('data-lang', 'turn-cam-on-text');
          $("#toggleVideoTrack span").html("videocam_off");
        }
      }

      $(".local-video").toggleClass("visible", state);

      let myLocalVideo = document.getElementById('localVideo');
      const streamLoaded = async () => {
        myLocalVideo.removeEventListener('loadedmetadata', streamLoaded);
        console.log('streamLoaded!!!!!!!!!!!');
        this._model.dispatchEvent({ type: SCENE_INTERACTION.USER_VIDEO_STATE_CHANGED, data: { 'userVideoOn': state, 'on1on1Call': isBusy } });
      }
      myLocalVideo.addEventListener('loadedmetadata', streamLoaded);


    } catch (exception) {
      console.error('_setMyVideo Enabled', exception);
    }

  }

  _setMyAudioEnabled = async (enabled) => {
    console.log('_setMyAudio Enabled: ', enabled);
    try {
      // if (this._localStream) {
      //   this._localStream.getAudioTracks().forEach((track) => {
      //     track.enabled = enabled
      //   });
      // }

      this._myAudioShareEnabled = enabled;

      // this.audioToggle.prop('checked', enabled);

      if (enabled) {
        if (this.camAdaptor) {
          this.camAdaptor.unmuteLocalMic();
        }
        //TODO toggles in separate function
        $("#toggleAudioTrack p").text($trans('turn-mic-off-text'));
        $("#toggleAudioTrack p").attr("data-lang", "turn-mic-off-text");
        $("#toggleAudioTrack span").html("mic");
      } else {
        if (this.camAdaptor) {
          this.camAdaptor.muteLocalMic();
        }
        $("#toggleAudioTrack p").text($trans('turn-mic-on-text'));
        $("#toggleAudioTrack p").attr("data-lang", "turn-mic-on-text");
        $("#toggleAudioTrack span").html("mic_off");
      }

    } catch (exception) {
      console.error('VRWebRtcController.getAudioTracks()', exception);
    }
  }

  _sendData(payload) {
    if (this._currentScopeId) {
      this._socket && this._socket.getSocket().emit('webRtcData', { ...payload, scopeId: this._currentScopeId, userId: this.userProperties.userId, userVideoOn: this.userProperties.userVideoOn });
    }
  }

  _sendSignalData(payload) {
    if (this._currentScopeId) {
      this._socket && this._socket.getSocket().emit('signalData', { ...payload, scopeId: this._currentScopeId, userId: this.userProperties.userId, userVideoOn: this.userProperties.userVideoOn, userScreenShareOn: this.userProperties.userScreenShareOn });
    }
  }

  controlWebrtcScreenShareStream = (state, objId, userId) => {
    // console.log('controlWebrtcScreenShareStream', state,objId);
    if (!state) {
      // this._removeTrack();
    }
    this._model.dispatchEvent({ type: SCENE_INTERACTION.USER_SCREEN_SHARE_STATE_CHANGED, data: { 'userScreenShareOn': state, 'objId': objId, 'userId': userId } });
  }

  //for 1 on 1 calls 
  _createdDescription(description, peerUuid) {
    if (!this._peerConnections[peerUuid]) {
      return;
    }
    this._peerConnections[peerUuid].pc.setLocalDescription(description).then(() => {
      this._sendData({
        'sdp': this._peerConnections[peerUuid].pc.localDescription,
        'uuid': this._uuid,
        'userId': this.userProperties.userId,
        'dest': peerUuid,
      });
    }).catch(this._errorHandler);
  }
  //TODO check why this twice
  _removePeerConnection(peerUuid) {

    try {
      if (this._peerConnections[peerUuid]) {
        const peer = this._peerConnections[peerUuid];
        peer.pc.close();
        peer.pc.onicecandidate = null;
        peer.pc.ontrack = null;
        if (peer.videoElement) {
          peer.videoElement.srcObject = null;
        }

        if (peer.userId) {
          console.log('%c WEBRTC_SOME_VIDEO_STOPPED', 'color:red');
          this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SOME_VIDEO_STOPPED, data: { userId: peer.userId } });
        }
      }

      console.log('this.usersList', this.usersList);

      const remoteVideoElement = document.getElementById('remoteVideo_' + peerUuid);
      if (remoteVideoElement) {
        console.log('%c remoteVideoElement', 'color:red');
        console.log(remoteVideoElement);
        document.getElementById('localVideoContainer').removeChild(remoteVideoElement);
      }
      console.log('%c removePeerConnection', 'color:red');
      console.log('this.streamsList', this.streamsList);
      console.log('this._currentScopeType', this._currentScopeType);
      if (this._currentScopeType === 'users') {
        // your 1:1 video call peer was disconnected
        console.log('hangUpCall called');
        this.hangUpCall(false);
      }


    } catch (exception) {
      console.error('VRWebRtcController._removePeer Connection()', exception);
    }
  }
  _removePeer_Connection(payload) {

    try {
      console.log('%c _removePeer _Connection', 'color:red');
      let peerUuid = payload.uuid;
      if (payload.stopped_streamId) {
        let stopped = payload.stopped_streamId;
        // console.log('stopped', stopped);
      }

      if (this._peerConnections[peerUuid]) {
        const peer = this._peerConnections[peerUuid];
        peer.pc.close();
        peer.pc.onicecandidate = null;
        peer.pc.ontrack = null;
        if (peer.videoElement) {
          // console.log('peer.videoElement',peer.videoElement);
          peer.videoElement.srcObject = null;
        }
        // if (peer.userId) {
        //   this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SOME_VIDEO_STOPPED, data: { userId: peer.userId } });
        // }
      }


      const remoteVideoElement = document.getElementById('remoteVideo_' + peerUuid);
      if (remoteVideoElement) {
        console.log('%c remoteVideoElement', 'color:red');
        console.log(remoteVideoElement);
        document.getElementById('localVideoContainer').removeChild(remoteVideoElement);
      }
      // let user  = this._socket.getUserScreenData(obj.streamId);
      if (this._currentScopeType === 'users') {
        // your 1:1 video call peer was disconnected
        this.hangUpCall(true, true);
        // if(this._localStream){
        //   this.hangUpCall(true,true);
        //   console.log('has seat stream');
        // }else{
        //   this.hangUpCall(true,false);
        // }
      }


    } catch (exception) {
      console.error('_removePeer _Connection', exception);
    }
  }
  _stop = async (removePeers = true, dispatch = true) => {
    try {

      this._peerConnections = {};

      let stopped_streamId = false;

      if (this._local1on1Stream && removePeers) {

        stopped_streamId = this._formatStreamId(this._local1on1Stream.id);
        this._local1on1Stream.getTracks().forEach(track => track.stop());
        this._local1on1Stream = null;
        if (document.getElementById('own-video-call').srcObject) {
          let stream = document.getElementById('own-video-call').srcObject;
          stream.getTracks().forEach(track => track.stop());
          document.getElementById('own-video-call').srcObject = null;
        }

      }
      if (dispatch) {
        this._sendData({
          'stopConnection': true,
          'uuid': this._uuid,
          'userId': this.userProperties.userId,
          'dest': 'all',
          'stopped_streamId': stopped_streamId,
        });

        this._sendSignalData({
          'type': 'user-stopped-1on1',
          'uuid': this._uuid,
          'userId': this.userProperties.userId,
          'dest': 'all', //TODO
          'stopped_streamId': stopped_streamId,
        });
      }


      this._currentScopeType = null;
      this._currentScopeId = null;
      this._currentScopeDisplayName = null;
      this.started1on1 = false;

      $("#grid-view-option").addClass("disabled");

    } catch (exception) {
      console.error('VRWebRtcController._stop()', exception);
    }
  }

  controller = () => {

    this._socket.addEventListener(SOCKET_EVENTS.SOCKET_READY, this.init);
    this._socket.addEventListener(SOCKET_EVENTS.APTIS_WEB_RTC_DATA, this.aptisWebRtcData);
    this._socket.addEventListener(SOCKET_EVENTS.APTIS_WEBRTC_SIGNAL, this.aptisWebRtcSignalData);
    this._socket.addEventListener(SOCKET_EVENTS.USER_DATA_CHANGED, this.updateUserProperties);


    this._socket.addEventListener(SOCKET_EVENTS.USER_DISCONNECTED, () => {
      // setTimeout(() => {
      //   // this._checkPeerConnections() //TODO 
      // }, 1000)
    });

    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_START_SCOPE, (e) => {
      console.log('WEBRTC_START_SCOPE', e.data);
      const { scopeType, scopeId, scopeName, withCamera, withAudio, constraints } = e.data;
      if (e.data.unique_id) {//&& scopeType
        this.screenObjId = e.data.unique_id;
        // console.log('before start scope screenshare - e.data.unique_id:',e.data.unique_id); //TODO
        this.start(scopeType, scopeId, scopeName, withCamera, withAudio, constraints, null, e.data.unique_id);
        return;
      } else {
        // console.log('before start scope scene');
        this.start(scopeType, scopeId, scopeName, withCamera, withAudio, constraints);
      }
    });

    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_STOP_SCOPE, () => {
      // console.log('WEBRTC_STOP_SCOPE');
      if (this._localStream) {
        let streamId = this._formatStreamId(this._localStream.id);
        this._stopBroadcasting(streamId);
      }

    });

    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_START_STREAM, async () => {
      console.log('WEBRTC_START_STREAM');
      console.log('activeOneOnOneCall: ', this._model.activeOneOnOneCall);
      await this._setMyVideoEnabled(true, this._model.activeOneOnOneCall);
      this._model.iSitOnThisVRChair !== null && this._model.iSitOnThisVRChair.useVideoMaterial();
    });

    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_STOP_STREAM, async () => {
      console.log('WEBRTC_STOP_STREAM');
      console.log('activeOneOnOneCall: ', this._model.activeOneOnOneCall);
      await this._setMyVideoEnabled(false, this._model.activeOneOnOneCall);
      this._model.iSitOnThisVRChair !== null && this._model.iSitOnThisVRChair.useAvatarMaterial(this._model.userAvatarTexture);
    });


    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_USER_STARTED_SCREEN_SHARE, (e) => {
      console.log('WEBRTC_USER_STARTED_SCREEN_SHARE', e.data);
      this.controlWebrtcScreenShareStream(e.data.userScreenShareOn, e.data.unique_id, this._model.config.userId);
    });
    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_STOP_SCREEN_SHARE, () => {
      // console.log('WEBRTC_STOP_SCREEN_SHARE');
      if (this._localScreenStream) {
        let streamId = this._formatStreamId(this._localScreenStream.id);
        this._stopScreenBroadcasting(streamId);
      }

      this.controlWebrtcScreenShareStream(false, this.screenObjId, this._model.config.userId);
      $("#screen-share-video").get(0).srcObject = null;
      if ($(".localVideoWrapper").hasClass('focus-mode') && $("#active-focused-element").val() === 'screen-share-video') {
        $(".localVideoWrapper").removeClass('focus-mode');
      }
      $(".localVideoWrapper").hasClass('grid-mode') && this._model.calculateGridDimensions();
    });

    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_TOGGLE_AUDIO, (e) => {
      // console.log('this._model.iStream',this._model.iStream);
      // console.log('startStreamWithVideoPuppet',$("#startStreamWithVideoPuppet"));
      // console.log(this._myAudioShareEnabled);
      this._model.iStream.audio = !this._myAudioShareEnabled;
      this._setMyAudioEnabled(!this._myAudioShareEnabled);
    });

    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_TOGGLE_SCREEN_AUDIO, (e) => {
      console.log('WEBRTC_TOGGLE_SCREEN_AUDIO'); //TODO test
      // this._model.iSitOnThisVRChair !== null && this._model.iSitOnThisVRChair.toggleAudio(!this._myAudioShareEnabled); this method doesn't exist anymore
      // this._model.iStream.audio = !this._myAudioShareEnabled;
      // this._setMyAudioEnabled(!this._myAudioShareEnabled);
    });

    this._model.addEventListener(WEBRTC_EVENTS.SCENE_CHANGED, (e) => {
      const { scene } = e.data;
      this._currentSceneId = scene.id;
      this._currentSceneName = scene.publicName;

      if (scene && this._currentScopeType !== 'users') {
        this._stop();
      }
    });

    this._model.addEventListener(WEBRTC_EVENTS.REQUEST_SCREEN_SHARE, (e) => {

      console.log('REQUEST_SCREEN_SHARE', e.data);
      const { ownerId, objID } = e.data;

      // console.log('this.userProperties.userId', this.userProperties);

      // Prevent user to call itself: action possible via owner profile
      let requestorId = this.userProperties.userId;
      if (ownerId === requestorId) {
        //this._model.alert('error', $trans('error-calling-yourself'));
        return;
      }
      let requestorName = this.userProperties.userName;
      this._currentScopeType = 'screenShare';


    });

    this._model.addEventListener(WEBRTC_EVENTS.OWNER_SCREEN_SHARE, (e) => {

      const { ownerId, objID } = e.data;
      let requestorId = this.userProperties.userId;
      if (ownerId === requestorId) {
        console.log('OWNER_SCREEN_SHARE', e.data);
      }

    });

    this._model.addEventListener(WEBRTC_EVENTS.NEW_STREAM_ON_PUBLIC_STAGE, async (e) => {
      if (this.publicAdaptor) {
        console.log('EXISTS!', e.data);
        console.log(this.publicAdaptor);
      }

      if (!e.data.userdata.userId) {
        return;
      }

      if (this.camAdaptor || this.screenAdaptor) {
        console.log('return, another adaptor exists');
        return;
      }
      console.log(e.data);
      console.log('%c NEW_STREAM_ON_PUBLIC_STAGE ', 'background:pink');

      let userId = e.data.userdata.userId;
      let userVideoOn = e.data.userdata.userVideoOn;
      let userScreenShareOn = e.data.userdata.userScreenShareOn;
      let obj3Did = e.data.obj3Did;
      let id = null;
      let videoId = null;
      if (e.data.userdata.webcamStreamId && e.data.userdata.screenStreamId) {
        //TODO both
        console.log('streaming BOTH cam and screen this.streamsList', this.streamsList);
      }
      if (e.data.userdata.webcamStreamId) {
        console.log('cam: ', e.data.userdata.webcamStreamId);
        if (!this.streamsList.includes(e.data.userdata.webcamStreamId)) {
          id = e.data.userdata.webcamStreamId;
          videoId = 'remoteVideo' + id;
          this.publicAdaptor = await this.initPublicAdaptor(id, videoId, userId, userVideoOn, userScreenShareOn, obj3Did, this.publicCallback);
        }
      }
      //else if(e.data.userdata.screenStreamId){ //TODO if share cam then screen. stop screen, new publicGuest joins
      if (e.data.userdata.screenStreamId) {
        console.log('screen: ', e.data.userdata.screenStreamId);
        if (!this.streamsList.includes(e.data.userdata.screenStreamId)) {
          id = e.data.userdata.screenStreamId;
          videoId = 'screenShareVideo_' + id;
          this.publicAdaptor = await this.initPublicAdaptor(id, videoId, userId, userVideoOn, userScreenShareOn, obj3Did, this.publicCallback);
        }
      }

    });

    this._model.addEventListener(WEBRTC_EVENTS.LEFT_PUBLIC_STAGE, async (e) => {
      if (this.publicAdaptor) {
        console.log('LEFT_PUBLIC_STAGE user: ', e.data);
        if (e.data == this.userProperties.userId) {

          console.log('%c LEFT_PUBLIC_STAGE ', 'background:red; padding:5px 10px');
          console.log(this.publicAdaptor);

          let streams = this.publicAdaptor.playStreamId;
          console.log('streams', streams);
          for (let i = 0; i < streams.length; i++) {
            const stream = streams[i];
            // this.publicAdaptor.stop(stream);
            this.publicAdaptor.closeWebSocket();
            this.publicAdaptor.closePeerConnection(stream);
            this.removeRemoteVideo(stream);
          }
          this.publicInterval = true;
          this.publicAdaptor = null;
          this._model.guestJoinedPublicStage = false;
          this._model.iPlayPublicStream = false;
        }

        // console.log('this.publicAdaptor', this.publicAdaptor);
      }
    });


    // INITIATE 1:1 CALL
    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE, async (e) => {
      const { item } = e.data;

      // Prevent user to call itself: action possible via owner profile
      if (item.userId === this.userProperties.userId) {
        this._model.alert('error', $trans('error-calling-yourself'));
        return;
      }

      // console.log('item.userName',item.userName);
      if (!item.hasOwnProperty('userName')) {
        console.log('socket here');
        let getUser = this._socket.getUsers()[item.userId]
        console.log('getUser', getUser);
        item.userName = getUser.userName;
        item.userAvatarUrl = getUser.userAvatarUrl;
      }

      await this.one_on_one_disableStreams();

      console.log('WEBRTC_VIDEO_ONE_ON_ONE', e.data);
      if (this._currentScopeType === 'users') {

        const classToBeRemoved = `video_notification_from_${this.userProperties.userId}`;
        this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, data: { classToBeRemoved } });
      }

      if ($(`.video_notification_from_${item.userId}`).length) {

        this._model.confirm(`${item.userName} ${$trans('confirm-already-calling-you-answer')}`, () => {
          $(`.video_notification_from_${item.userId}`).children('.call_cta').children('.respond_video_call').trigger('click');
        });
        return;
      }

      this.peerInfo = item;
      const constraints = {
        cameraDevice: $('#settings_camera').val(),
        microphoneDevice: $('#settings_microphone').val()
      }
      const scopeId = `${this.userProperties.userId}_${item.userId}`;
      const scopeName = `1:1 ${this.userProperties.userName} - ${item.userName}`;
      const withCamera = true; // TODO - grab this from some settings/dialog
      const withAudio = true; // TODO - grab this from some settings/dialog

      // this.controlWebrtcVideo Stream(false, true);

      $(".loading-spinner").addClass('visible');
      await this.start('users', scopeId, scopeName, withCamera, withAudio, constraints);
      // SHOW 1:1 VIDEO LAYER
      this.displayCallOverlay(this.peerInfo.userAvatarUrl, this.peerInfo.userName, this.peerInfo.userId);
      this._model.activeOneOnOneCall = true;
    });



    $('body').on('click', '.video-wrapper .videoLabel', (event) => { //TODO remove
      event.stopPropagation();
      const userId = $(this).data('user-id');
      const userName = $(this).data('user-name');
      console.log(userId, userName)
      // if (userId && userName) {
      //     $('body').trigger('aptis-open-user-chat', [userId, userName || '']);
      // }
    });

    $('#submit_media_settings').on("click", async (e) => {
      let audio = $("#settings_microphone").val();
      let video = $("#settings_camera").val();
      let soundDevice = $(".speakerSelect").val();
      if (this._localStream) {
        //changing device live while streaming
        console.log('#speakerSelect', $("#speakerSelect").val());
        console.log('.speakerSelect', $(".speakerSelect").val());
        // console.log('microphoneDevice',audio);
        // console.log('cameraDevice',video);
        // console.log('soundDevice',soundDevice);
        $(".loading-spinner").addClass('visible');
        if (this.camAdaptor) { //TODO screenAdaptor


          let mediaConstraints = { audio: { deviceId: { exact: audio } }, video: { deviceId: { exact: video } } };
          console.log(this.camAdaptor);
          if (this.camAdaptor.localStream && this.camAdaptor.localStream.active) {

          }
          console.log('localStream.active: ', this.camAdaptor.localStream.active);
          let oldMediaConstraints = this.camAdaptor.mediaConstraints;
          console.log('oldMediaConstraints', oldMediaConstraints);
          console.log('mediaConstraints', mediaConstraints);
          if (oldMediaConstraints != mediaConstraints) {
            // this.camAdaptor.closeStream();
            console.log('media constraints are different!!');
            await this._closeStream(); //TODO how to close stream?
            // this.camAdaptor.stop();
            let myLocalVideo = document.getElementById('localVideo');

            // console.log('localStream.active: ', this.camAdaptor.localStream.active);
            if (!this.camAdaptor.localStream.active) {
              await this._openStream(mediaConstraints);
              const switchStreamLoaded = async () => {
                myLocalVideo.removeEventListener('loadedmetadata', switchStreamLoaded);
                console.log('switchStreamLoaded!!!!!!!!!!!');
                // console.log('localStream.active: ', this.camAdaptor.localStream.active);
                if (oldMediaConstraints.video.deviceId.exact != video) {
                  this.camAdaptor.switchVideoCameraCapture(this.camAdaptor.publishStreamId, video);
                }
                if (oldMediaConstraints.audio.deviceId.exact != audio) {
                  this.camAdaptor.switchAudioInputSource(this.camAdaptor.publishStreamId, audio);
                }
              }
              myLocalVideo.addEventListener('loadedmetadata', switchStreamLoaded);
            }
          }
        }
      } else {//TODO screen and 1on1
        //before stream
        if (localStorage.hasOwnProperty('microphoneDevice')) {
          console.log('audio l ', localStorage.getItem('microphoneDevice'));
          console.log('audio:', audio);
        }
        if (localStorage.hasOwnProperty('cameraDevice')) {
          console.log('video l ', localStorage.getItem('cameraDevice'));
          console.log('video:', video);
        }
        if (localStorage.hasOwnProperty('soundDevice')) {
          console.log('soundDevice l ', localStorage.getItem('soundDevice'));
          console.log('soundDevice:', soundDevice);
        }
      }

      localStorage.setItem('microphoneDevice', audio);
      localStorage.setItem('cameraDevice', video);
      localStorage.setItem('soundDevice', soundDevice);

      this._model.activePreviewVideoModal = false;
      this._model.endTestStream();
      $(".media-settings-form").removeClass("is-active");
      $("#submit_media_settings").addClass('disabled');
      $(".loading-spinner").removeClass('visible');
    });


    // TOGGLE VIDEO NOTIFICATION CONTAINER ON/OFF
    $("#notification_toggle_button").on('click', () => {
      $("#notifications_holder").toggleClass('expanded');
    });


    $(document).on('click', '.approve_screen_share', (e) => {
      const index = $('.approve_screen_share').index(e.target);
      const removeElement = $('.call_unique_class').eq(index).val();
      const scopeId = $('.call_scope_id').eq(index).val();
      const objID = $('.call_objID').eq(index).val();
      const scopeName = $('.call_scope_name').eq(index).val();
      const callInitiatorID = removeElement.replace('video_notification_from_', '');
      this.removeNotification(removeElement);
      //this.start('screenShare', scopeId, scopeName, true, false, {}, removeElement);

      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SCREEN_APPROVED, data: { callInitiatorID, scopeId, objID } });
    });
    $(document).on('click', '.deny_screen_share', (e) => {
      const index = $('.respond_video_call').index(e.target);
      const removeElement = $('.call_unique_class').eq(index).val();
      const scopeId = $('.call_scope_id').eq(index).val();
      const callInitiatorID = removeElement.replace('video_notification_from_', '');
      this.removeNotification(removeElement);

      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SCREEN_DENIED, data: { callInitiatorID, scopeId } });
    });


    // ANSWER INCOMING 1:1 CALL
    $(document).on('click', '.respond_video_call', async (e) => {
      console.log('respond_video_call');
      // console.log('activeOneOnOneCall::: ', this._model.activeOneOnOneCall);

      const index = $('.respond_video_call').index(e.target);
      const withAudio = $('.call_with_audio').eq(index).val();
      const withCamera = $('.call_with_video').eq(index).val();
      const scopeId = $('.call_scope_id').eq(index).val();
      const scopeName = $('.call_scope_name').eq(index).val();
      const removeElement = $('.call_unique_class').eq(index).val();
      const peerAvatarUrl = $('.call_sender_img').eq(index).attr('src');
      const peerName = $('.call_sender_name').eq(index).text();
      const callInitiatorID = removeElement.replace('video_notification_from_', '');
      const constraints = {
        cameraDevice: $('#settings_camera').val(),
        microphoneDevice: $('#settings_microphone').val()
      }
      console.log('peerName', peerName);
      this.displayCallOverlay(peerAvatarUrl, peerName, callInitiatorID);
      $(".loading-spinner").addClass('visible');

      await this.one_on_one_disableStreams();
      if (this._model.activeOneOnOneCall) {
        console.log('I am already on a call while I respond to another incoming call!');
      }
      console.log('call withCamera, withAudio', withCamera, withAudio);
      await this.start('users', scopeId, scopeName, withCamera, withAudio, constraints, removeElement);
      this._model.activeOneOnOneCall = true;

    });
    // REJECT INCOMING 1:1 CALL
    $(document).on('click', '.reject_video_call', (e) => {
      console.log('reject_video_call');
      const index = $('.respond_video_call').index(e.target);
      const removeElement = $('.call_unique_class').eq(index).val();
      const scopeId = $('.call_scope_id').eq(index).val();
      const callInitiatorID = removeElement.replace('video_notification_from_', '');
      this.removeNotification(removeElement);

      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_REJECTED, data: { callInitiatorID, scopeId } });
    });


    this._model.addEventListener(WEBRTC_EVENTS.WEBRTC_SOMEONE_REJECTED_YOUR_CALL, async (e) => {
      const { scopeId } = e.data;
      if (scopeId === this._currentScopeId) {
        console.log('WEBRTC_SOMEONE_REJECTED_YOUR_CALL', e.data);
        // console.log('hang Up Call called');
        if (this.userProperties.userId == e.data.callInitiatorID) {
          console.log('My call was rejected ', this._model.iStream);
          if (this._localStream) {
            await this._setMyVideoEnabled(this._model.iStream.video, false);
            await this._setMyAudioEnabled(this._model.iStream.audio);
          }
        }
        await this.hangUpCall(true, false);
      }
    });

    // POSSIBLE CALL RECEIVER GOT DISCONNECTED
    this._model.addEventListener(GLOBAL_EVENTS.SESSION_DISCONNECTED, (e) => {
      console.log('SESSION_DISCONNECTED ', e);
      if (this._currentScopeType === 'users') {
        if (this.peerInfo.userId === e.id) {
          // the user you are calling got disconnected
          this._model.alert('warning', $trans('error-call-friend-disconnected'));
          this.hangUpCall();
        }
      }
    });

    // HANG UP 1:1 CALL
    $(".end-call-btn").on('click', async () => {
      console.log('%c end-call-video-one-on-one!!!', 'color:red');
      console.log('this.started1on1', this.started1on1);
      const classToBeRemoved = `video_notification_from_${this.userProperties.userId}`;
      if (document.getElementById('peer-video-call').srcObject == null) {
        // console.log('peer srcObject',$("#peer-video-call").get(0).srcObject);
        console.log('I hang up before call initiated!');
        if (this._localStream) {
          await this._setMyVideoEnabled(this._model.iStream.video, false);
          await this._setMyAudioEnabled(this._model.iStream.audio);
        }
      }
      this._model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, data: { classToBeRemoved } });
      this.hangUpCall(true, true);
    });


  }

  displayCallOverlay(peerAvatarUrl, peerUsername, id = false) {
    $("#own-avatar-call").attr('src', this.userProperties.userAvatarUrl);
    $("#own-avatar-call").show();
    $("#own-label-call").text(this.userProperties.userName);
    $("#peer-avatar-call").attr('src', peerAvatarUrl);
    $("#peer-avatar-call").show();
    $("#peer-label-call").text(peerUsername);
    id && $("#peer-avatar-call").attr('data-id', `avatar_${id}`);
    id && $("#peer-label-call").attr('data-id', `username_${id}`);
    id && $("#one-on-one-video-call-peer-id").val(`${id}`);
    $("#oneOnOneVideoContainer").addClass('active');
  }

  _closeStream = async () => {
    console.log('%c _close Stream', 'color:red');
    this.camAdaptor.closeStream();
    console.log('this._localStream', this._localStream);
    if (this._localStream) {
      this._localStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }
  _openStream = async (mediaConstraints) => {
    console.log('%c _open Stream', 'color:green');
    this.camAdaptor.openStream(mediaConstraints);
  }


  hangUpCall = async (removePeers = true, dispatch = true) => {
    console.log('%c hangUpCall', 'color:red');

    $("#oneOnOneVideoContainer").removeClass('active');
    this._model.activeOneOnOneCall = false;

    await this._stop(removePeers, dispatch);

    if (this._localStream) {
      $('#my-own-video-wrapper').removeClass('on-1on1-call');
      $('#my-own-video-wrapper').removeClass('hidden');
      console.log('peer srcObject', $("#peer-video-call").get(0).srcObject);
    }

    $("#own-video-call").get(0).srcObject = null;
    $("#peer-video-call").get(0).srcObject = null;
    $(".call-line").removeClass('active');
    this.peerInfo = {};
    // $("#gridToggle").addClass('hidden');
    $(".video-label-call").removeClass('temp-label');

    $(".loading-spinner").removeClass('visible');

    if (this.myAudioLevelsAnalyzer) {
      this.myAudioLevelsAnalyzer.end();
      this.myAudioLevelsAnalyzer = null;
    }

    if (this.peerAudioLevelsAnalyzer) {
      this.peerAudioLevelsAnalyzer.end();
      this.peerAudioLevelsAnalyzer = null;
    }

    $('#one-on-one-video-call-peer-id').val('');

  }

}

export { WebRtc }
